var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.options)?_c('div',[_c('e-chart',{ref:"echartRef",attrs:{"option":_vm.options},on:{"click":_vm.onClick}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }